module.exports = __webpack_public_path__ + "img/NO817244742.2dacde22.png";